import React from 'react';
import classNames from 'classnames';
import Icon from '../icon';

const CheckmarkIcon = ({ animated = false, size = 24, strokeWidth = 1.3 }) => {
  const classes = classNames('ws-ui-checkmark-icon', {
    'ws-ui-checkmark-icon--animated': animated,
  });

  return (
    <div className={classes}>
      <Icon glyph="check" type="success" size={size} strokeWidth={strokeWidth} />
    </div>
  );
};

export default CheckmarkIcon;
